/**
 * DIDIHIST — DIDI Histograma.
 *
 * Migrado do Silverlight (GraficoDePrata/Formulas/FMLTrend.cs, classe
 * FML.DIDIHIST), painel próprio (PlotInNewAxis=true):
 *
 *   Short = MA(C,HIGHMA) − MA(C,MIDMA)
 *   Long  = MA(C,LOWMA)  − MA(C,MIDMA)
 *   Histogram = Short − Long                 (COLORSTICK: verde >0, vermelho ≤0)
 *   Center    = MA(C,MIDMA) − MA(C,MIDMA) = 0 (linha zero pontilhada vermelha)
 *
 * MA = média aritmética do engine (silverlightDsl.ma). A ordem de operações é
 * a MESMA do engine (Short − Long, sem simplificar para MA(HIGH)−MA(LOW)) para
 * bater bit-a-bit no float. O histograma emite valor a partir de
 * max(HIGH,MID,LOW)−1 barras (warm-up NaN); a linha zero é desenhada pela série.
 * COLORSTICK do engine colore por SINAL (FormulaArea.cs:2120). Paridade provada
 * em __tests__/didiHist.silverlight.test.js.
 */
import { getSourcePathAccessor } from "../utils";
import { ma, sub } from "./silverlightDsl";
import { DIDIHIST as defaultOptions } from "./defaultOptionsForComputation";

export default function () {
  let options = defaultOptions;

  function calculator(data) {
    const { highPeriod, midPeriod, lowPeriod, sourcePath } = options;

    const source = getSourcePathAccessor(sourcePath);
    const c = data.map((d, i) => {
      const v = source(d, i);
      return Number.isFinite(v) ? v : NaN;
    });

    const maHigh = ma(c, highPeriod);
    const maMid = ma(c, midPeriod);
    const maLow = ma(c, lowPeriod);
    const shortD = sub(maHigh, maMid);
    const longD = sub(maLow, maMid);
    const hist = sub(shortD, longD);

    // { value, direction } — shape do ColoredHistogramSeries. Direção por sinal
    // (>0 verde/up, ≤0 vermelho/down), igual ao COLORSTICK do engine.
    return hist.map((v) =>
      Number.isFinite(v)
        ? { value: v, direction: v > 0 ? "up" : "down" }
        : undefined,
    );
  }

  calculator.undefinedLength = function () {
    const { highPeriod, midPeriod, lowPeriod } = options;
    return Math.max(0, Math.max(highPeriod, midPeriod, lowPeriod) - 1);
  };

  calculator.options = function (x) {
    if (!arguments.length) {
      return options;
    }
    options = { ...defaultOptions, ...x };
    return calculator;
  };

  return calculator;
}
